import { useMutation } from '@tanstack/react-query';
import Tooltip from '@tippyjs/react';
import React from 'react';

import { useTranslations } from '~src/commons/utils/translations/translate';
import { apiInstance, useGlobalState, useGlobalStateUpdate } from '~src/global-state';
import { QuestionMarkIcon } from '~src/icons/question-mark';
import { colors } from '~src/theme/colors';
import { fontStyles } from '~src/theme/fontStyles';
import { Checkbox } from '~src/ui/checkbox';

import { useHasAddress } from '~address-form/utils/address-utils';

export const ConsolidateCheckbox: React.FC = () => {
  const { tICU } = useTranslations();
  const updateGlobalState = useGlobalStateUpdate();
  const globalState = useGlobalState();
  const hasAddress = useHasAddress();
  const isConsolidatable = globalState.delivery_groups_context?.consolidation_allowed;
  const consolidated = !!globalState.delivery_groups_context?.consolidation_enabled;

  const updateConsolidation = useMutation({
    mutationFn: async () => {
      const { data } = await apiInstance.v4.deliveryGroupsContextPatch(
        globalState.checkout_session_id,
        { enable_consolidation: !consolidated }
      );
      return data;
    },
    mutationKey: ['consolidation'],
    onSuccess: state_response => {
      updateGlobalState(state_response);
    },
  });

  const isPreAddress =
    !hasAddress && !globalState.sessions[0].flags.show_shipping_categories_before_address;

  if (!isConsolidatable || isPreAddress) {
    return null;
  }

  return (
    <div css={styles.checkbox} className="conditional-blur">
      <Checkbox
        labelId="consolidate-checkbox"
        checked={consolidated}
        onChange={() => updateConsolidation.mutate()}
      />
      <label css={styles.label} htmlFor="consolidate-checkbox">
        {tICU('widget.consolidation.title')}
      </label>
      <Tooltip content={tICU('widget.consolidation.description')} trigger="mouseenter focus click">
        <div css={styles.icon}>
          <QuestionMarkIcon color={colors.black} />
        </div>
      </Tooltip>
    </div>
  );
};

const styles = {
  icon: {
    alignItems: 'center',
    display: 'flex',
    marginLeft: '4px',
  },
  checkbox: {
    position: 'relative' as const,
    display: 'flex',
    ...fontStyles.px14_20,
    padding: '4px 0',
    margin: '16px 0',
  },
  label: {
    marginLeft: '6px',
    cursor: 'pointer',
  },
};
